import {
  collection,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
  getDocs,
  query,
  orderBy,
  serverTimestamp,
  Timestamp,
  writeBatch,
} from "firebase/firestore";
import { db } from "./config";
import { ImpactSlide } from "../types/impactSlides";

export type CourseStatus = "draft" | "published";

export interface Course {
  id?: string;
  slug: string;
  title: string;
  tagline: string;
  description: string;
  labels?: string[];
  coverImageUrl?: string;
  coverImageIsPlaceholder?: boolean;
  status: CourseStatus;
  featured?: boolean;
  impactSlides?: ImpactSlide[];
  impactAnimated?: boolean;
  order: number;
  createdAt?: Timestamp;
  updatedAt?: Timestamp;
}

const coursesCollection = collection(db, "courses");

export const getAllCourses = async (): Promise<Course[]> => {
  const snapshot = await getDocs(query(coursesCollection, orderBy("order", "asc")));
  return snapshot.docs.map((docSnap) => ({ id: docSnap.id, ...docSnap.data() } as Course));
};

export const createCourse = async (
  course: Omit<Course, "id" | "createdAt" | "updatedAt">
): Promise<string> => {
  const docRef = await addDoc(coursesCollection, {
    ...course,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  });
  return docRef.id;
};

export const updateCourse = async (
  id: string,
  course: Partial<Omit<Course, "id" | "createdAt" | "updatedAt">>
): Promise<void> => {
  await updateDoc(doc(db, "courses", id), {
    ...course,
    updatedAt: serverTimestamp(),
  });
};

export const deleteCourse = async (id: string): Promise<void> => {
  await deleteDoc(doc(db, "courses", id));
};

export const reorderCourses = async (orderedIds: string[]): Promise<void> => {
  const batch = writeBatch(db);
  orderedIds.forEach((id, index) => {
    batch.update(doc(db, "courses", id), { order: index, updatedAt: serverTimestamp() });
  });
  await batch.commit();
};
